/*
 * iurop-birthday — Página de cumpleaños Kawaicafe.
 * 1) Carrusel de locales (flechas que desplazan un slide, ocultas en los extremos).
 * 2) Pop-up de reserva: lo abren los CTA sin enlace ([data-bday-open]); cierra con
 *    X / overlay / Escape. Al abrir se mueve al <body> para que ningún overflow
 *    de la sección lo recorte (mismo patrón que el modal de iurop-locations).
 * 3) Calendario real del mes en curso (lunes primero, hoy con anillo, pasado
 *    tachado, día elegido con relleno). Sin dependencias.
 */
(function () {
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  // ---------------------------------------------------------------- carrusel
  function initCarousel(root) {
    if (root.dataset.kbInit) return;
    root.dataset.kbInit = '1';
    var track = root.querySelector('[data-kb-track]');
    var prev = root.querySelector('[data-kb-prev]');
    var next = root.querySelector('[data-kb-next]');
    if (!track) return;
    function step() {
      var sl = track.querySelector('.kawaii-bday-loc__slide');
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return sl ? sl.offsetWidth + gap : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    }
    // Mismo desplazamiento que la home: se REDONDEA al paso de tarjeta en vez de
    // sumar un delta al scroll actual. Con `scrollBy` el encaje de scroll-snap
    // corregia la posicion despues y los saltos salian desiguales (486, 161...)
    // en vez de una tarjeta entera por clic.
    function go(dir) {
      var p = step();
      if (!p) return;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var t = Math.round((track.scrollLeft + dir * p) / p) * p;
      track.scrollTo({ left: Math.max(0, Math.min(t, max)), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ------------------------------------------------ pantalla de la tele
  // Carrusel de fotos dentro del marco del conejito: flechas, puntos, arrastre
  // con el dedo y avance solo. Con una unica foto no se activa nada.
  function initTv(root) {
    if (root.dataset.kbTv) return;
    root.dataset.kbTv = '1';
    var track = root.querySelector('[data-bday-tv-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    root.classList.add('is-carousel');

    var prev = root.querySelector('[data-bday-tv-prev]');
    var next = root.querySelector('[data-bday-tv-next]');
    var dotsWrap = root.querySelector('[data-bday-tv-dots]');
    var i = 0, timer = null, dots = [];

    if (dotsWrap) {
      for (var k = 0; k < n; k++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'kawaii-bday__tv-dot' + (k === 0 ? ' is-on' : '');
        d.setAttribute('aria-label', 'Foto ' + (k + 1));
        (function (idx) { d.addEventListener('click', function () { go(idx, true); }); })(k);
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }

    function paint(anim) {
      track.style.transition = anim ? '' : 'none';
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
    }
    // EN BUCLE: al llegar a la ultima foto la flecha (o el arrastre) vuelve a la
    // primera en vez de quedarse bloqueada (QA cumples: "hay una ultima foto que
    // no desliza"). Por eso tampoco se ocultan las flechas en los extremos.
    function go(to, manual) {
      i = ((to % n) + n) % n;
      paint(true);
      if (manual) restart();
    }
    function auto() { go((i + 1) % n); }
    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(auto, 5000);
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });

    // Arrastre (dedo y raton). El umbral evita robar el scroll vertical.
    var x0 = null, dx = 0, dragging = false;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Las flechas y los puntos viven DENTRO de root: si aqui se captura el
      // puntero, el navegador redirige el pointerup a root y ya NO dispara el
      // click del boton -> las flechas dejaban de funcionar (QA cumples).
      if (e.target.closest && e.target.closest('button')) return;
      x0 = e.clientX; dx = 0; dragging = true;
      try { root.setPointerCapture(e.pointerId); } catch (_) {}
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - x0;
      if (Math.abs(dx) > 4) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + dx + 'px))';
      }
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      var umbral = Math.max(24, root.clientWidth * 0.18);
      if (dx <= -umbral) go(i + 1, true);
      else if (dx >= umbral) go(i - 1, true);
      else { track.style.transition = ''; paint(true); }
      dx = 0;
    }
    root.addEventListener('pointerup', end);
    root.addEventListener('pointercancel', end);
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    paint(false);
    restart();
  }

  // -------------------------------------------------------------- calendario
  function initCalendar(popup) {
    var cal = popup.querySelector('[data-bday-cal]');
    if (!cal || cal.dataset.kbCal) return;
    cal.dataset.kbCal = '1';
    var monthEl = cal.querySelector('[data-bday-month]');
    var daysEl = cal.querySelector('[data-bday-days]');
    var prevBtn = cal.querySelector('[data-bday-prev]');
    var nextBtn = cal.querySelector('[data-bday-next]');
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var minAvailable = new Date(today);
minAvailable.setDate(minAvailable.getDate() + 3);

    var view = new Date(today.getFullYear(), today.getMonth(), 1);
    var selected = null;
    var localSelect = popup.querySelector('[data-bday-local]');

    function parseClosed(value) {
      var out = {};
      String(value || '').split(/[\s,;]+/).forEach(function (iso) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) out[iso] = true;
      });
      return out;
    }
    function isoOf(date) {
      return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    }
    function isAvailable(date) {
      var weekday = date.getDay();
      if (date < minAvailable || weekday === 0 || weekday === 6) return false;

      var closed = parseClosed(popup.getAttribute('data-bday-closed'));
      var option = localSelect && localSelect.options[localSelect.selectedIndex];
      var localClosed = parseClosed(option && option.getAttribute('data-closed'));
      return !closed[isoOf(date)] && !localClosed[isoOf(date)];
    }

    // ---- Hora: mismo flujo que el calendario de Talleres -------------------
    // Al elegir el dia se abre un pop-up con las horas; debajo del calendario
    // queda el resumen "dia · hora" con un boton para cambiarla.
    var hpop = popup.querySelector('[data-bday-hpop]');
    var horasBox = popup.querySelector('[data-bday-horas]');
    var pick = popup.querySelector('[data-bday-pick]');
    var pickTxt = popup.querySelector('[data-bday-pick-txt]');
    var hpopDay = popup.querySelector('[data-bday-hpop-day]');
    var horas = horasBox
      ? (horasBox.getAttribute('data-horas') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean)
      : [];
    var pideHora = !!(hpop && horasBox && horas.length);
    var selHora = '';
    // Un `position: fixed` deja de serlo si un ancestro tiene transform/filter:
    // el pop-up de horas vive en el <body>, como el de la reserva.
    if (hpop && hpop.parentNode !== document.body) document.body.appendChild(hpop);

    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    function fechaLarga(d) {
      return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MONTHS[d.getMonth()].toLowerCase();
    }
    function abrirHoras() {
      if (!pideHora || !selected) return;
      if (hpopDay) hpopDay.textContent = fechaLarga(selected);
      hpop.hidden = false;
    }
    function cerrarHoras() { if (hpop) hpop.hidden = true; }
    function pintarHoras() {
      if (!pideHora) return;
      horasBox.innerHTML = '';
      horas.forEach(function (h) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kawaii-bday-popup__hour' + (h === selHora ? ' is-on' : '');
        b.textContent = h;
        b.setAttribute('aria-pressed', h === selHora ? 'true' : 'false');
        b.addEventListener('click', function () {
          selHora = h;
          popup.dataset.bdayHora = h;
          pintarHoras();
          cerrarHoras();
          popup.dispatchEvent(new CustomEvent('bday:selection-change'));
        });
        horasBox.appendChild(b);
      });
      if (pick) {
        pick.hidden = !selected;
        if (pickTxt) pickTxt.textContent = selected ? (fechaLarga(selected) + (selHora ? ' · ' + selHora : '')) : '';
      }
    }
    if (pideHora) {
      hpop.addEventListener('click', function (e) {
        if (e.target.closest('[data-bday-hpop-close]')) cerrarHoras();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !hpop.hidden) cerrarHoras();
      });
      var pickOpen = popup.querySelector('[data-bday-pick-open]');
      if (pickOpen) pickOpen.addEventListener('click', abrirHoras);
      pintarHoras();
    }

    function sameDay(a, b) {
      return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }
    function render() {
      monthEl.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      if (prevBtn) {
        var isCurrentMonth = view <= new Date(today.getFullYear(), today.getMonth(), 1);
        prevBtn.disabled = isCurrentMonth;
        prevBtn.style.visibility = isCurrentMonth ? 'hidden' : 'visible';
        prevBtn.setAttribute('aria-hidden', isCurrentMonth ? 'true' : 'false');
      }
      daysEl.innerHTML = '';
      var lead = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7; // lunes = 0
      var total = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var i;
      for (i = 0; i < lead; i++) {
        var empty = document.createElement('span');
        empty.className = 'kawaii-bday-popup__day is-empty';
        daysEl.appendChild(empty);
      }
      for (i = 1; i <= total; i++) {
        var date = new Date(view.getFullYear(), view.getMonth(), i);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kawaii-bday-popup__day';
        btn.textContent = i;
        if (sameDay(date, today)) btn.classList.add('is-today');
        if (date < today) {
          btn.classList.add('is-past');
          btn.disabled = true;
          btn.setAttribute('aria-hidden', 'true');
        } else if (!isAvailable(date)) {
          btn.classList.add('is-unavailable');
          btn.disabled = true;
          btn.setAttribute('aria-label', i + ', no disponible');
        } else {
          // Dia reservable: relleno rosa, igual que el calendario de Talleres
          // (QA cumpleanos: "los dias disponibles en rosa / morado").
          btn.classList.add('is-av');
        }
        if (sameDay(date, selected)) btn.classList.add('is-selected');
        (function (d) {
          btn.addEventListener('click', function () {
            selected = d;
            // Fecha LOCAL (toISOString pasa a UTC y en España restaría un día).
            popup.dataset.bdayDate = isoOf(d);
            render();
            pintarHoras();
            abrirHoras();
            popup.dispatchEvent(new CustomEvent('bday:selection-change'));
          });
        })(date);
        daysEl.appendChild(btn);
      }
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
      render();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
      render();
    });
    popup.kbRestoreSelection = function (dateValue, hourValue) {
      var parts = (dateValue || '').split('-').map(Number);
      if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
        var restored = new Date(parts[0], parts[1] - 1, parts[2]);
        if (restored >= today && isAvailable(restored)) {
          selected = restored;
          view = new Date(restored.getFullYear(), restored.getMonth(), 1);
          popup.dataset.bdayDate = dateValue;
        }
      }
      if (hourValue && horas.indexOf(hourValue) !== -1) {
        selHora = hourValue;
        popup.dataset.bdayHora = hourValue;
      }
      render();
      pintarHoras();
    };
    if (localSelect) localSelect.addEventListener('change', function () {
      if (selected && !isAvailable(selected)) {
        selected = null;
        selHora = '';
        delete popup.dataset.bdayDate;
        delete popup.dataset.bdayHora;
        cerrarHoras();
        pintarHoras();
        popup.dispatchEvent(new CustomEvent('bday:selection-change'));
      }
      render();
    });
    render();
  }

  // ---------------------------------------------------------- formulario pasos
  function initWizard(popup) {
    if (!popup || popup.hasAttribute('data-bday-native') || popup.dataset.kbWizard) return;
    popup.dataset.kbWizard = '1';
    var panel = popup.querySelector('.kawaii-bday-popup__panel');
    var steps = Array.prototype.slice.call(popup.querySelectorAll('[data-bday-step]'));
    var progress = Array.prototype.slice.call(popup.querySelectorAll('[data-bday-progress]'));
    var lines = Array.prototype.slice.call(popup.querySelectorAll('.kawaii-bday-popup__progress-line'));
    var progressWrap = popup.querySelector('.kawaii-bday-popup__progress');
    var back = popup.querySelector('[data-bday-back]');
    var next = popup.querySelector('[data-bday-next-step]');
    var submit = popup.querySelector('[data-bday-reservar]');
    var error = popup.querySelector('[data-bday-error]');
    var summary = popup.querySelector('[data-bday-summary]');
    var success = popup.querySelector('[data-bday-success]');
    var successSummary = popup.querySelector('[data-bday-success-summary]');
    var actions = popup.querySelector('.kawaii-bday-popup__actions');
    var privacy = popup.querySelector('[data-bday-privacy]');
    var title = popup.querySelector('.kawaii-bday-popup__title');
    var originalTitle = title ? title.textContent : '';
    var current = 1;
    var storageKey = 'kawaii-bday-request:' + (popup.getAttribute('data-kb-owner') || 'default');

    function storageRead() {
      try { return JSON.parse(window.sessionStorage.getItem(storageKey) || '{}'); }
      catch (storageError) { return {}; }
    }
    function storageWrite() {
      var localSelect = popup.querySelector('[data-bday-local]');
      var data = {
        local: localSelect ? localSelect.value : '',
        date: popup.dataset.bdayDate || '',
        hour: popup.dataset.bdayHora || '',
        name: (popup.querySelector('[data-bday-name]') || {}).value || '',
        people: (popup.querySelector('[data-bday-personas]') || {}).value || '',
        phone: (popup.querySelector('[data-bday-contacto]') || {}).value || '',
        email: (popup.querySelector('[data-bday-email]') || {}).value || ''
      };
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(data)); }
      catch (storageError) { /* El formulario sigue funcionando sin almacenamiento. */ }
    }
    function storageRestore() {
      var data = storageRead();
      var localSelect = popup.querySelector('[data-bday-local]');
      if (localSelect && data.local) localSelect.value = data.local;
      [
        ['[data-bday-name]', data.name],
        ['[data-bday-personas]', data.people],
        ['[data-bday-contacto]', data.phone],
        ['[data-bday-email]', data.email]
      ].forEach(function (pair) {
        var field = popup.querySelector(pair[0]);
        if (field && pair[1]) field.value = pair[1];
      });
      if (popup.kbRestoreSelection) popup.kbRestoreSelection(data.date, data.hour);
    }

    function clearError() {
      if (!error) return;
      error.textContent = '';
      error.hidden = true;
    }
    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }
    function readableDate(value) {
      if (!value) return '';
      var parts = value.split('-');
      return parts.length === 3 ? (parts[2] + '/' + parts[1] + '/' + parts[0]) : value;
    }
    function paintSummary() {
      if (!summary) return;
      var localSelect = popup.querySelector('[data-bday-local]');
      var local = localSelect ? localSelect.value : '';
      var date = readableDate(popup.dataset.bdayDate || '');
      var hour = popup.dataset.bdayHora || '';
      summary.innerHTML = '';
      [
        { label: 'Local', value: local, step: 1 },
        { label: 'Fecha y hora', value: date + ' · ' + hour, step: 2 }
      ].forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'kawaii-bday-popup__summary-row';
        var copy = document.createElement('span');
        var label = document.createElement('small');
        var value = document.createElement('strong');
        var edit = document.createElement('button');
        label.textContent = item.label;
        value.textContent = item.value;
        copy.appendChild(label);
        copy.appendChild(value);
        edit.type = 'button';
        edit.textContent = 'Cambiar';
        edit.setAttribute('data-bday-edit-step', String(item.step));
        edit.setAttribute('aria-label', 'Cambiar ' + item.label.toLowerCase());
        row.appendChild(copy);
        row.appendChild(edit);
        summary.appendChild(row);
      });
    }
    function go(step, animate) {
      current = Math.max(1, Math.min(3, step));
      popup.dataset.bdayCurrentStep = String(current);
      if (title) title.textContent = originalTitle;
      if (success) success.hidden = true;
      if (progressWrap) progressWrap.hidden = false;
      if (actions) actions.hidden = false;
      steps.forEach(function (node) {
        var active = parseInt(node.getAttribute('data-bday-step'), 10) === current;
        node.hidden = !active;
        node.classList.toggle('is-active', active && animate !== false);
      });
      progress.forEach(function (node, index) {
        var number = index + 1;
        node.classList.toggle('is-active', number === current);
        node.classList.toggle('is-done', number < current);
        if (number === current) node.setAttribute('aria-current', 'step');
        else node.removeAttribute('aria-current');
      });
      lines.forEach(function (line, index) { line.classList.toggle('is-done', current > index + 1); });
      if (back) back.hidden = current === 1;
      if (next) next.hidden = current === 3;
      if (submit) submit.hidden = current !== 3;
      if (privacy) privacy.hidden = current !== 3;
      if (current === 3) paintSummary();
      clearError();
      if (panel) panel.scrollTo({ top: 0, behavior: animate === false ? 'auto' : 'smooth' });
    }
    function showSuccess() {
      popup.dataset.bdaySubmitted = 'true';
      steps.forEach(function (node) { node.hidden = true; });
      if (progressWrap) progressWrap.hidden = true;
      if (actions) actions.hidden = true;
      if (privacy) privacy.hidden = true;
      clearError();
      if (title) title.textContent = '¡Gracias!';
      if (successSummary) {
        paintSummary();
        successSummary.textContent = summary
          ? Array.prototype.map.call(summary.querySelectorAll('strong'), function (node) { return node.textContent; }).join(' · ')
          : '';
      }
      if (success) {
        success.hidden = false;
        success.focus({ preventScroll: true });
      }
      try { window.sessionStorage.removeItem(storageKey); }
      catch (storageError) { /* No bloquea la confirmación. */ }
      popup.dispatchEvent(new CustomEvent('bday:request-success'));
      if (panel) panel.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function validateStep() {
      if (current === 2) {
        if (!popup.dataset.bdayDate) {
          showError('Selecciona una fecha para continuar.');
          return false;
        }
        if (!popup.dataset.bdayHora) {
          showError('Selecciona una hora para continuar.');
          return false;
        }
      }
      return true;
    }

    if (next) next.addEventListener('click', function () {
      if (validateStep()) go(current + 1, true);
    });
    if (back) back.addEventListener('click', function () { go(current - 1, true); });
    if (summary) summary.addEventListener('click', function (event) {
      var edit = event.target.closest('[data-bday-edit-step]');
      if (edit) go(parseInt(edit.getAttribute('data-bday-edit-step'), 10), true);
    });
    popup.addEventListener('bday:selection-change', function () {
      clearError();
      storageWrite();
    });
    popup.querySelectorAll('select, input').forEach(function (field) {
      field.addEventListener('change', function () { clearError(); storageWrite(); });
      field.addEventListener('input', function () { clearError(); storageWrite(); });
      field.addEventListener('focus', function () {
        if (window.matchMedia('(max-width: 749px)').matches) {
          window.setTimeout(function () { field.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 280);
        }
      });
    });
    storageRestore();
    popup.kbGoStep = go;
    popup.kbShowSuccess = showSuccess;
    popup.kbSaveDraft = storageWrite;
    go(1, false);
  }

  // ------------------------------------------------------------------ pop-up
  function openPopup(popup, opener) {
    if (!popup) return;
    popup.kbReturnFocus = opener || null;
    if (popup.parentNode !== document.body) document.body.appendChild(popup);
    if (popup.kbGoStep) popup.kbGoStep(1, false);
    popup.setAttribute('data-open', 'true');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('data-modal-open', 'true');
    var closeBtn = popup.querySelector('[data-bday-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closePopup(popup) {
    if (!popup) return;
    popup.removeAttribute('data-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('data-modal-open');
    if (popup.kbReturnFocus && popup.kbReturnFocus.isConnected) {
      popup.kbReturnFocus.focus({ preventScroll: true });
    }
    popup.kbReturnFocus = null;
  }

  function initSection(section) {
    if (section.dataset.kbSection) return;
    section.dataset.kbSection = '1';
    var popup = section.querySelector('[data-bday-popup]') ||
      document.querySelector('[data-bday-popup][data-kb-owner="' + section.dataset.sectionId + '"]');
    if (popup) {
      popup.setAttribute('data-kb-owner', section.dataset.sectionId || '');
      initCalendar(popup);
      initWizard(popup);
      var requestForm = popup.querySelector('.kawaii-bday-popup__form');
      if (requestForm && !requestForm.dataset.kbRequest) {
        requestForm.dataset.kbRequest = '1';
        requestForm.noValidate = true;
        requestForm.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (Number(popup.dataset.bdayCurrentStep) < 3) {
            var nextStep = requestForm.querySelector('[data-bday-next-step]');
            if (nextStep) nextStep.click();
            return;
          }
          var requestButton = requestForm.querySelector('[data-bday-reservar]');
          if (requestButton) requestButton.click();
        });
        var requestButton = requestForm.querySelector('[data-bday-reservar]');
        if (requestButton) requestButton.addEventListener('click', submitRequest);
        // Avoid scrolling to a hidden form on the server's return navigation.
        requestForm.action = requestForm.action.split('#')[0];
        var returnField = requestForm.querySelector('[name="return_to"]');
        if (returnField) {
          var returnUrl = new URL(returnField.value, window.location.origin);
          var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewId) returnUrl.searchParams.set('preview_theme_id', previewId);
          returnField.value = returnUrl.pathname + returnUrl.search;
        }
      }
      if (popup.querySelector('[data-bday-server-success]')) {
        openPopup(popup);
        if (popup.kbShowSuccess) popup.kbShowSuccess();
      } else {
        var serverErrors = popup.querySelector('[data-bday-server-errors]');
        if (serverErrors) {
          openPopup(popup);
          if (popup.kbGoStep) popup.kbGoStep(3, false);
          var errorMessage = popup.querySelector('[data-bday-error]');
          if (errorMessage) {
            errorMessage.textContent = serverErrors.textContent.trim();
            errorMessage.hidden = false;
          }
        }
      }
    }
    section.querySelectorAll('[data-bday-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openPopup(popup, btn); });
    });
    // "Ver menú": abre su PROPIO pop-up (imagen del menú), no el de reserva.
    var menuPopup = section.querySelector('[data-bday-menu-popup]');
    section.querySelectorAll('[data-bday-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openPopup(menuPopup, btn); });
    });
    section.querySelectorAll('[data-kb-carousel]').forEach(initCarousel);
    section.querySelectorAll('[data-bday-tv]').forEach(initTv);
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-bday-close]');
    // Cierra el pop-up que contiene la X/overlay pulsado (reserva O menú).
    if (close) closePopup(close.closest('.kawaii-bday-popup'));
  });

  function prepareBirthdayCaptcha(form) {
    return new Promise(function (resolve, reject) {
      var captcha = window.Shopify && window.Shopify.captcha;
      var message = 'No se ha podido completar la verificación de seguridad. Comprueba tu conexión e inténtalo de nuevo.';
      if (!captcha || typeof captcha.protect !== 'function') {
        reject(new Error(message));
        return;
      }
      var timer = window.setTimeout(function () { reject(new Error(message)); }, 15000);
      try {
        captcha.protect(form, function () {
          window.clearTimeout(timer);
          resolve();
        });
      } catch (error) {
        window.clearTimeout(timer);
        reject(new Error(message));
      }
    });
  }

  // Shopify prepares the anti-spam token through its supported form.submit().
  // A raw fetch bypasses that flow. Only the returned Liquid success marker
  // opens the receipt; starting the submission is not confirmation of delivery.
  async function submitRequest(e) {
    e.preventDefault();
    var cta = e.currentTarget;
    var form = cta.closest('form');
    if (!form || form.dataset.bdaySubmitting === 'true') return;
    var popup = form.closest('[data-bday-popup]');
    var sel = popup && popup.querySelector('[data-bday-local]');
    var nameInput = popup && popup.querySelector('[data-bday-name]');
    var personasInput = popup && popup.querySelector('[data-bday-personas]');
    var contactoInput = popup && popup.querySelector('[data-bday-contacto]');
    var emailInput = popup && popup.querySelector('[data-bday-email]');
    var error = popup && popup.querySelector('[data-bday-error]');
    var opt = sel && sel.options[sel.selectedIndex];
    var recipient = (opt && opt.getAttribute('data-email')) || '';
    var local = sel ? sel.value : '';
    var date = popup ? (popup.dataset.bdayDate || '') : '';
    var hora = popup ? (popup.dataset.bdayHora || '') : '';
    var customerName = nameInput ? nameInput.value.trim() : '';
    var personas = personasInput ? parseInt(personasInput.value, 10) : 0;
    var contacto = contactoInput ? contactoInput.value.trim() : '';
    var customerEmail = emailInput ? emailInput.value.trim() : '';
    var contactoDigitos = contacto.replace(/\D/g, '');
    var mensaje = '';

    [nameInput, personasInput, contactoInput, emailInput].forEach(function (input) {
      if (input) input.removeAttribute('aria-invalid');
    });
    if (!date) mensaje = 'Selecciona una fecha para la solicitud.';
    else if (!hora) mensaje = 'Selecciona una hora para la solicitud.';
    else if (customerName.length < 2) {
      mensaje = 'Indica tu nombre para poder gestionar la solicitud.';
      if (nameInput) nameInput.setAttribute('aria-invalid', 'true');
    }
    else if (!personas || personas < 10) {
      mensaje = 'Indica un mínimo de 10 personas.';
      if (personasInput) personasInput.setAttribute('aria-invalid', 'true');
    } else if (contactoDigitos.length < 9) {
      mensaje = 'Indica un número de contacto válido.';
      if (contactoInput) contactoInput.setAttribute('aria-invalid', 'true');
    } else if (!customerEmail || !emailInput.checkValidity()) {
      mensaje = 'Indica un correo electrónico válido.';
      if (emailInput) emailInput.setAttribute('aria-invalid', 'true');
    }
    if (mensaje) {
      if (error) { error.textContent = mensaje; error.hidden = false; }
      var invalid = popup.querySelector('[aria-invalid="true"]');
      if (invalid) invalid.focus();
      return;
    }
    if (error) { error.textContent = ''; error.hidden = true; }

    var body = 'Solicitud de reserva de cumpleaños en Kawaii Café.\n\n'
      + 'Nombre: ' + customerName + '\n'
      + 'Local: ' + local + '\n'
      + 'Fecha: ' + date + '\n'
      + 'Hora: ' + hora + '\n'
      + 'Número de personas: ' + personas + '\n'
      + 'Teléfono de contacto: ' + contacto + '\n'
      + 'Correo electrónico: ' + customerEmail + '\n\n'
      + 'La reserva queda pendiente de confirmación por parte del local.';
    var dateField = form.querySelector('[data-bday-form-date]');
    var hourField = form.querySelector('[data-bday-form-hour]');
    var recipientField = form.querySelector('[data-bday-form-recipient]');
    var bodyField = form.querySelector('[data-bday-form-body]');
    if (dateField) dateField.value = date;
    if (hourField) hourField.value = hora;
    if (recipientField) recipientField.value = recipient;
    if (bodyField) bodyField.value = body;
    if (popup.kbSaveDraft) popup.kbSaveDraft();

    var label = cta && cta.querySelector('[data-bday-submit-label]');
    var loading = cta && cta.querySelector('[data-bday-submit-loading]');
    form.dataset.bdaySubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if (cta) { cta.disabled = true; cta.setAttribute('aria-busy', 'true'); }
    if (label) label.hidden = true;
    if (loading) loading.hidden = false;

    try {
      await prepareBirthdayCaptcha(form);
      form.submit();
      // Never auto-retry an unconfirmed submission: it may already have arrived.
      window.setTimeout(function () {
        if (error) {
          error.textContent = 'El envío aún no se ha confirmado. Completa la verificación si aparece. Si no puedes continuar, recarga la página para intentarlo de nuevo.';
          error.hidden = false;
        }
        if (loading) loading.hidden = true;
        if (label) label.hidden = false;
        form.removeAttribute('aria-busy');
        cta.removeAttribute('aria-busy');
      }, 60000);
    } catch (requestError) {
      if (error) {
        error.textContent = requestError.message || 'No hemos podido enviar la solicitud. Inténtalo de nuevo.';
        error.hidden = false;
      }
      if (popup) popup.dispatchEvent(new CustomEvent('bday:request-error'));
      delete form.dataset.bdaySubmitting;
      form.removeAttribute('aria-busy');
      if (cta) { cta.disabled = false; cta.removeAttribute('aria-busy'); }
      if (label) label.hidden = false;
      if (loading) loading.hidden = true;
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.kawaii-bday-popup[data-open]');
      if (open) closePopup(open);
    }
  });

  function boot() { document.querySelectorAll('.kawaii-bday').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.kawaii-bday');
    if (s) initSection(s);
  });
})();
